var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"mx-auto",attrs:{"height":_vm.size,"src":`https://cdn.vuetifyjs.com/docs/images/logos/vuetify-logo-${_vm.theme.isDark ? 'dark' : 'light'}-atom.svg`,"width":_vm.size,"max-width":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }